export const ACTIVE_SEASON_ALERT_SET_IGNORE = 'ACTIVE_SEASON_ALERT_SET_IGNORE';
